import StoreHeader from "../../components/layout/StoreHeader";
import StoreFooter from "../../components/layout/StoreFooter";
import { useSettings } from "../../context/SettingsContext";
import { Phone, Mail, MapPin, Clock, MessageCircle } from "lucide-react";

export default function Contact() {
  const { settings } = useSettings();
  const phone   = settings.store_phone   || "0406 291 986";
  const phone2  = settings.store_phone_2 || "1800 650 650";
  const email   = settings.store_email   || "info@brisbanecarparts.com.au";
  const hours   = settings.business_hours || "Mon–Fri 8:00am–5:30pm · Sat 9:00am–1:00pm";

  return (
    <div className="bg-white min-h-screen" data-testid="contact-page">
      <StoreHeader />

      {/* Page header */}
      <section className="bg-[#0b1a3b] text-white py-16">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-[#e31e24] font-mono text-xs uppercase tracking-[0.3em] mb-2">Get in Touch</div>
          <h1 className="font-heading text-4xl md:text-5xl font-bold uppercase">Contact Brisbane Car Parts</h1>
          <p className="mt-3 text-blue-100 max-w-xl">
            Questions about a part, fitment, or shipping? Our Brisbane team is ready to help.
          </p>
        </div>
      </section>

      {/* Contact cards */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 grid grid-cols-1 md:grid-cols-3 gap-6">

        {/* Phone */}
        <div className="border border-zinc-200 rounded-sm p-7 hover:border-[#1e5bb8] hover:shadow-md transition-all">
          <div className="w-11 h-11 bg-[#e31e24]/10 border border-[#e31e24]/20 rounded-sm flex items-center justify-center mb-4">
            <Phone className="h-5 w-5 text-[#e31e24]" />
          </div>
          <div className="font-heading font-black uppercase text-[#0b1a3b] text-[15px] mb-3">Phone</div>
          <a href={`tel:${phone.replace(/\s/g,"")}`}
            className="block text-[#1e5bb8] font-heading text-lg font-bold hover:text-[#0b3ea0] transition-colors">
            {phone}
          </a>
          {phone2 && (
            <a href={`tel:${phone2.replace(/\s/g,"")}`}
              className="block text-[#1e5bb8] font-heading text-lg font-bold hover:text-[#0b3ea0] transition-colors mt-1">
              {phone2}
            </a>
          )}
          <div className="mt-3 flex items-center gap-1.5 text-[12px] text-zinc-500">
            <Clock className="h-3.5 w-3.5" /> {hours}
          </div>
        </div>

        {/* Email */}
        <div className="border border-zinc-200 rounded-sm p-7 hover:border-[#1e5bb8] hover:shadow-md transition-all">
          <div className="w-11 h-11 bg-[#e31e24]/10 border border-[#e31e24]/20 rounded-sm flex items-center justify-center mb-4">
            <Mail className="h-5 w-5 text-[#e31e24]" />
          </div>
          <div className="font-heading font-black uppercase text-[#0b1a3b] text-[15px] mb-3">Email</div>
          <a href={`mailto:${email}`}
            className="block text-[#1e5bb8] font-heading font-bold hover:text-[#0b3ea0] transition-colors break-all">
            {email}
          </a>
          <p className="mt-3 text-[13px] text-zinc-500 leading-relaxed">
            We aim to respond within 2 business hours during operating hours.
          </p>
        </div>

        {/* Location */}
        <div className="border border-zinc-200 rounded-sm p-7 hover:border-[#1e5bb8] hover:shadow-md transition-all">
          <div className="w-11 h-11 bg-[#e31e24]/10 border border-[#e31e24]/20 rounded-sm flex items-center justify-center mb-4">
            <MapPin className="h-5 w-5 text-[#e31e24]" />
          </div>
          <div className="font-heading font-black uppercase text-[#0b1a3b] text-[15px] mb-3">Location</div>
          <div className="text-[14px] text-zinc-700 leading-relaxed">
            83 Teraba Street<br />
            Richlands QLD 4077<br />
            Australia
          </div>
          <a href="https://maps.google.com/?q=83+Teraba+Street+Richlands+QLD+4077"
            target="_blank" rel="noreferrer"
            className="inline-block mt-3 text-[12px] font-semibold text-[#1e5bb8] hover:underline">
            Get directions →
          </a>
        </div>
      </div>

      {/* Live chat CTA */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 pb-16">
        <div className="bg-[#1e5bb8] text-white p-10 rounded-sm flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <MessageCircle className="h-8 w-8 text-white shrink-0" />
            <div>
              <div className="font-heading text-2xl font-bold uppercase">Use Live Chat</div>
              <div className="text-blue-100 text-sm mt-1">
                Click the red bubble at the bottom-right to chat with our team now.
              </div>
            </div>
          </div>
          <div className="shrink-0 text-[13px] font-mono uppercase tracking-widest text-blue-200">
            Available during business hours
          </div>
        </div>
      </section>

      <StoreFooter />
    </div>
  );
}